export enum ScheduleSubpage {
    Modified,
    Usual,
}
